module.exports = __webpack_public_path__ + "img/18.adc4d6b5.png";